import React, { useState } from 'react'
import { Field } from 'formik'

import {
  Input,
  SelectButton,
  Container,
  Options,
} from './styles'
import TplGroup from '../tpl-group'
import IField from '../../../../interfaces/field'
import Icon from '../../../icon'

type IProps = any & IField

const SelectChecklist = ({
  required = false,
  name,
  prefixName,
  title,
  options,
  ...el
}: IProps) => {
  const [checklistIsOpen, setChecklistIsOpen] = useState(false)
  return (
    <TplGroup
      name={`${prefixName}${name}`}
      prefixName={prefixName}
      title={title}
      required={required}
      {...el}
    >
      <Container>
        <SelectButton onClick={() => setChecklistIsOpen((state: any) => !state)}>
          {el.placeholder}
          <Icon name="arrow-down" />
        </SelectButton>
        <Options
          style={{
            ...el.containerStyle,
            display: checklistIsOpen ? 'flex' : 'none',
          }}
        >
          {
            options.map((option: any) => (
              <div key={JSON.stringify(option)} style={{ ...el.style }}>
                <Field
                  type="checkbox"
                  name={name}
                  value={option?.value || option}
                  as={Input}
                />
                <span>{option?.label || option}</span>
              </div>
            ))
          }
        </Options>
      </Container>
    </TplGroup>
  )
}

export default SelectChecklist
